"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockAutoPxDiscount = exports.mockAutoPxBaseDiscount = exports.mockElectronicBaseDiscount = exports.mockElectronicDiscount = void 0;
exports.mockElectronicDiscount = {
    id: 2,
    description: 'electronic',
    rate: 5,
    total: 10,
    maxQuotas: 10,
    paymentMethod: 'TCR',
};
exports.mockElectronicBaseDiscount = {
    id: 2,
    rate: 5,
    maxQuotas: 10,
    total: 10,
};
exports.mockAutoPxBaseDiscount = {
    id: 3,
    rate: 10,
    maxQuotas: 11,
    total: 20,
};
exports.mockAutoPxDiscount = {
    id: 3,
    description: 'autoPx',
    rate: 10,
    total: 20,
    maxQuotas: 11,
    paymentMethod: 'TCR',
};
//# sourceMappingURL=mockDiscounts.js.map